/** A secret typed into a card's form; it never enters the chat messages or their history. */
export interface ProposalSecret {
  key: string;
  value: string;
}

/** How long stashed secrets wait for their confirm before they are dropped. */
export const PROPOSAL_SECRETS_TTL_MS = 60_000;

/** Secrets waiting for their card's confirm, in memory only, each with its expiry timer. */
const pending = new Map<
  string,
  { secrets: ProposalSecret[]; timer: ReturnType<typeof setTimeout> }
>();

/** Holds a card's secrets until its confirm sends them, or until they expire. */
export function stashProposalSecrets(proposalId: string, secrets: ProposalSecret[]): void {
  takeProposalSecrets(proposalId);
  const timer = setTimeout(() => pending.delete(proposalId), PROPOSAL_SECRETS_TTL_MS);
  pending.set(proposalId, { secrets, timer });
}

/** Hands a card's secrets to its confirm once and forgets them; empty when it has none. */
export function takeProposalSecrets(proposalId: string): ProposalSecret[] {
  const entry = pending.get(proposalId);
  if (entry === undefined) return [];
  clearTimeout(entry.timer);
  pending.delete(proposalId);
  return entry.secrets;
}
